/**
 * jsPDF default 14 fonts are WinAnsi-only; glyphs like ₹ (U+20B9) need a Unicode TTF.
 * Loads Noto Sans (regular + bold) from /public/fonts into the document VFS.
 */

export const PDF_UNICODE_FONT = "NotoSans";

const REGULAR_FILE = "NotoSans-Regular.ttf";
const BOLD_FILE = "NotoSans-Bold.ttf";

let fontBytesPromise = null;

function getFontBaseUrl() {
  const base =
    typeof process !== "undefined" && process.env && process.env.PUBLIC_URL != null
      ? String(process.env.PUBLIC_URL)
      : "";
  return base.replace(/\/$/, "");
}

function arrayBufferToBinaryString(buffer) {
  const bytes = new Uint8Array(buffer);
  const chunk = 0x8000;
  let binary = "";
  for (let i = 0; i < bytes.length; i += chunk) {
    binary += String.fromCharCode.apply(null, bytes.subarray(i, i + chunk));
  }
  return binary;
}

function loadFontBytes() {
  if (!fontBytesPromise) {
    const prefix = getFontBaseUrl();
    fontBytesPromise = Promise.all([
      fetch(`${prefix}/fonts/${REGULAR_FILE}`).then((r) => {
        if (!r.ok) throw new Error(`Failed to load ${REGULAR_FILE}`);
        return r.arrayBuffer();
      }),
      fetch(`${prefix}/fonts/${BOLD_FILE}`).then((r) => {
        if (!r.ok) throw new Error(`Failed to load ${BOLD_FILE}`);
        return r.arrayBuffer();
      }),
    ]).then(([regularBuf, boldBuf]) => ({
      regular: arrayBufferToBinaryString(regularBuf),
      bold: arrayBufferToBinaryString(boldBuf),
    }));
  }
  return fontBytesPromise;
}

/**
 * Registers Noto Sans on this jsPDF instance and sets it as the active font (normal).
 * Safe to call for every new document; font bytes are fetched once and reused.
 */
export async function loadJsPdfUnicodeFonts(doc) {
  const { regular, bold } = await loadFontBytes();

  if (!doc.existsFileInVFS(REGULAR_FILE)) {
    doc.addFileToVFS(REGULAR_FILE, regular);
    doc.addFont(REGULAR_FILE, PDF_UNICODE_FONT, "normal");
  }
  if (!doc.existsFileInVFS(BOLD_FILE)) {
    doc.addFileToVFS(BOLD_FILE, bold);
    doc.addFont(BOLD_FILE, PDF_UNICODE_FONT, "bold");
  }

  doc.setFont(PDF_UNICODE_FONT, "normal");
  return PDF_UNICODE_FONT;
}
